export default () => ({
  newResultType: {
    firm: 1,
    isInactive: false,
    sort: 0,
    year: null,
    vehicleMake: null,
    vehicleMakeName: '',
    driveType: null,
    driveTypeName: '',
    testdriveResultType: null,
    testdriveResultTypeName: '',
    testdriveResultCode: ''
  },
  newRecommendation: {
    testDriveRecommendation: null,
    driveType: null,
    firm: 1,
    isInactive: false,
    sort: 0,
    vehicleMake: null,
    vehicleMakeName: '',
    recommendation: '',
    recommendationText: null
  },
  recommendations: [],
  recommendation: null,
  criteriaChanged: false,
  step: 1,
  visitedStep: 1,
  translations: [],
  testdriveResultTypes: [],
  testdriveResultType: null
})



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/state.js